<template>
    <div class="FotavInputTable">
        <div class="flex-column">
            <div style="width: 100%; height: calc(100vh - 83px)">
                <DxDataGrid ref="FotavInputTableList"
                            :data-source="dataSource"
                            :column-auto-width="true"
                            :row-alternation-enabled="true"
                            :allow-column-resizing="true"
                            :show-row-lines="true"
                            :show-borders="true"
                            @initialized="onInitialized"
                            @init-new-row="onInitNewRow"
                            @row-prepared="onRowPrepared"
                            @toolbar-preparing="onToolbarPreparing"
                            height="100%">

                    <DxEditing :allow-deleting="true"
                               :use-icons="true" />

                    <DxPaging :page-size="20" />
                    <DxPager :visible="false" />
                    <DxFilterRow :visible="true"
                                 apply-filter="auto" />

                    <DxScrolling show-scrollbar="always"
                                 column-rendering-mode="standard"
                                 row-rendering-mode="standard"
                                 :mode="'virtual'"
                                 :preload-enabled="true" />

                    <DxColumn data-field="id"
                              caption="#"
                              :allowEditing="false"
                              width="50"
                              alignment="center"
                              cell-template="idColumnTemplate" />
                    <DxColumn data-field="filename"
                              caption="Fájlnév"
                              header-cell-template="title-header" />
                    <DxColumn data-field="size"
                              caption="Fájl mérete"
                              header-cell-template="title-header" />
                    <DxColumn data-field="issueDate"
                              caption="Hónap"
                              :customize-text="monthFormat"
                              header-cell-template="title-header"
                              alignment="left"
                              data-type="datetime" />
                    <DxColumn data-field="createdBy"
                              caption="Feltöltő"
                              header-cell-template="title-header" />
                    <DxColumn data-field="createdDate"
                              caption="Feltöltés dátuma"
                              :customize-text="dateFormat"
                              header-cell-template="title-header"
                              alignment="right"
                              data-type="datetime" />
                    <DxColumn caption="Akciók"
                              sortOrder="0"
                              :allow-resizing="false"
                              :allow-reordering="false"
                              :min-width="60"
                              :width="100"
                              type="buttons">
                        <DxButton name="edit"
                                  hint="Szerkesztés"
                                  icon="background"
                                  :visible="false" />
                        <DxButton name="save"
                                  hint="Mentés"
                                  icon="check" />
                        <DxButton name="cancel"
                                  hint="Mégsem"
                                  icon="close" />
                        <DxButton name="delete"
                                  hint="Törlés"
                                  icon="trash" />
                    </DxColumn>

                    <template #title-header="{ data }">
                        <div class="d-flex">
                            <div class="flex-1 text-left">{{ data.column.caption }}</div>
                        </div>
                    </template>

                    <template #idColumnTemplate="{ data: cellInfo }">
                        {{ rowId(cellInfo) }}
                    </template>

                    <template #uploadFile="{ data }">
                        <div>
                            <DxBtn name="upload"
                                   text="Fájl feltöltés"
                                   hint="Fájl feltöltés"
                                   icon="upload"
                                   @click="openPopup" />
                        </div>
                    </template>

                </DxDataGrid>
            </div>
        </div>

        <DxPopup width="400"
                 :height="350"
                 :show-title="true"
                 title="Szétosztási adatok sablon feltöltése"
                 :drag-enabled="false"
                 :close-on-outside-click="true"
                 :show-close-buttton="true"
                 :onInitialized="onPopupInit">

            <DxPopupToolbarItem widget="dxButton"
                                toolbar="bottom"
                                location="after"
                                :options="uploadBtn" />

            <DxPopupToolbarItem widget="dxButton"
                                toolbar="bottom"
                                location="after"
                                :options="closeBtn" />

            <template #content="{ data }">
                <div style="width:100%">
                    <div class="form-input">
                        <label>Szétosztási adatok</label>
                        <form>
                            <DxFileUploader select-button-text="Válassza ki a fájlt"
                                            ref="fileupload"
                                            label-text=""
                                            accept="text/xls"
                                            upload-mode="useForm" />
                        </form>
                    </div>
                    <div class="form-input">
                        <label>Elszámolási időszak (hónap)</label>
                        <DxDateBox v-model:value="selectedMonth"
                                   type="date"
                                   display-format="monthAndYear">

                            <DxCalendarOptions min-zoom-level="century"
                                               max-zoom-level="year" />
                        </DxDateBox>
                    </div>
                </div>
            </template>
        </DxPopup>

    </div>
</template>

<script>
    import DxList from "devextreme-vue/list";
    import FotavInputTableService from "../services/FotavInputTable.service";
    import DxForm, {
        DxItem as DxFormItem,
        DxButtonItem,
        DxLabel
    } from "devextreme-vue/form";
    import DxPopup, {
        DxToolbarItem as DxPopupToolbarItem
    } from "devextreme-vue/popup";
    import DxToolbar, { DxItem as DxToolbarItem } from "devextreme-vue/toolbar";
    import DxSelectBox from "devextreme-vue/select-box";
    import DxDataGrid, {
        DxGrouping,
        DxGroupPanel,
        DxSearchPanel,
        DxPaging,
        DxPager,
        DxSorting,
        DxScrolling,
        DxFilterRow,
        DxColumn,
        DxEditing,
        DxLookup,
        DxRequiredRule,
        DxPopup as DxDataGridEditPopup,
        DxPosition,
        DxForm as DxDatagridEditForm,
        DxButton,
        DxColumnFixing,
        DxRowDragging
    } from "devextreme-vue/data-grid";
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import CustomStore from "devextreme/data/custom_store";
    import { DxButton as DxBtn } from 'devextreme-vue/button';
    import notify from "devextreme/ui/notify";
    import { DxLoadPanel } from 'devextreme-vue/load-panel';
    import DxDateBox, { DxCalendarOptions } from 'devextreme-vue/date-box';
    import moment from 'moment';
    import { DxFileUploader } from 'devextreme-vue/file-uploader';

    export default {
        name: 'FotavInputTable',
        components: {
            DxPopup,
            DxFormItem,
            DxButtonItem,
            DxLabel,
            DxForm,
            DxToolbarItem,
            DxPopupToolbarItem,
            DxSelectBox,
            DxList,
            DxGrouping,
            DxGroupPanel,
            DxSearchPanel,
            DxPaging,
            DxPager,
            DxSorting,
            DxScrolling,
            DxFilterRow,
            DxColumn,
            DxEditing,
            DxLookup,
            DxRequiredRule,
            DxPosition,
            DxDatagridEditForm,
            DxButton,
            DxDataGridEditPopup,
            DxColumnFixing,
            DxRowDragging,
            DxDataGrid,
            DxScrollView,
            DxToolbar,
            DxBtn,
            DxLoadPanel,
            DxDateBox,
            DxCalendarOptions,
            DxFileUploader
        },
        data() {
            return {
                datagrid: null,
                dataSource: new CustomStore({
                    key: "id",
                    load: () => FotavInputTableService.get(),
                    insert: (values) => {
                        return FotavInputTableService.insert(values);
                    },
                    update: (key, values, reorder) =>
                        FotavInputTableService.update({
                            key: key,
                            values: JSON.stringify(values)
                        }),
                    remove: key => FotavInputTableService.delete(key)
                }),
                selectedMonth: moment().subtract(1, 'months'),
                closeBtn: {
                    icon: 'close',
                    text: 'Mégsem',
                    onClick: () => this.popup.hide()
                },
                uploadBtn: {
                    icon: 'upload',
                    text: 'Feltöltés',
                    onClick: () => this.importFile()
                },
            };
        },
        methods: {
            onInitialized(e, level) {
                this.datagrid = e.component;
            },
            onInitNewRow(e) {
                new Promise(resolve => setTimeout(resolve, 10)).then(() => {
                    e.component.saveEditData();
                    e.component.deselectAll();
                });
            },
            onRowPrepared(e) {
                if (e.component.getVisibleRows()[e.rowIndex] &&
                    e.component.getVisibleRows()[e.rowIndex].isNewRow &&
                    e.rowType == 'data')
                    e.rowElement.classList.add('d-none');
            },
            rowId: function (cellInfo) {
                return cellInfo.row.rowIndex + 1;
            },
            onToolbarPreparing(e) {
                e.toolbarOptions.items.unshift({
                    location: 'after',
                    template: 'uploadFile'
                });
            },
            openPopup() {
                if (this.popup) {
                    this.popup.show();
                }
            },
            onPopupInit(e) {
                this.popup = e.component;
            },
            importFile() {
                var fileExtension = ['xml', 'xls', 'xlsx'];
                var filename = this.$refs.fileupload.instance._files[0].value.name;

                if (filename.length == 0) {
                    notify({
                        message: 'Válasszon ki egy excel fájlt!',
                        position: {
                            at: "top",
                            offset: "0 40"
                        }
                    }, "error", 5000);
                    return false;
                }
                else {
                    var extension = filename.replace(/^.*\./, '');
                    if (!fileExtension.includes(extension)) {
                        notify({
                            message: 'A fájl típusa nem megfelelő!',
                            position: {
                                at: "top",
                                offset: "0 40"
                            }
                        }, "error", 5000);
                        return false;
                    }
                }

                var fdata = new FormData();
                fdata.append('issueMonth', moment(this.selectedMonth).format('YYYY-MM-DD'));

                var fileUpload = this.$refs.fileupload.instance;
                var files = fileUpload._files;
                fdata.append(files[0].value.name, files[0].value);

                this.popup.hide();
                this.datagrid.beginCustomLoading('Fájl feltöltése folyamatban...');
                let that = this;

                FotavInputTableService.import(fdata)
                    .then(result => {
                        this.datagrid.endCustomLoading();
                        this.datagrid.refresh();

                        notify({
                            message: 'Az importálás sikeresen befejeződött!',
                            position: {
                                at: "top",
                                offset: "0 40"
                            }
                        }, "success", 5000);
                    });
            },
            dateFormat(cellInfo) {
                var options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
                var formatter = new Intl.DateTimeFormat('hu-HU', options);
                return formatter.format(new Date(cellInfo.value));
            },
            monthFormat(cellInfo) {
                var options = { year: 'numeric', month: 'long' };
                var formatter = new Intl.DateTimeFormat('hu-HU', options);
                return formatter.format(new Date(cellInfo.value));
            }
        }
    }
</script>

<style lang="scss" scoped>
    #mapScrollview {
        height: 100%;
    }

    ::v-deep .grid {
        fill-opacity: 0;
    }

    ::v-deep .dx-scrollable {
        width: 100%;
    }

    ::v-deep .dx-scrollable-content {
        padding-bottom: 0 !important;
    }

    ::v-deep .dx-datagrid-header-panel .dx-toolbar {
        margin-top: 10px;
        margin-bottom: 10px;
        padding-right: 10px;
    }

    ::v-deep .dx-datagrid-edit-popup .dx-state-readonly {
        border: none !important;
    }

    .positionid {
        display: block;
        float: left;
        width: 19px;
        text-align: right;
        margin-right: 3px;
    }

    ::v-deep .dx-datagrid, ::v-deep .dx-toolbar {
        background-color: transparent;
    }

    ::v-deep .dx-toolbar-text-auto-hide .dx-button .dx-icon {
        line-height: 20px;
    }

    ::v-deep .warning-row {
        background-color: #f9f2b1 !important;
        border-color: #f9f2b1 !important;
    }

    ::v-deep .dx-fileuploader-files-container {
        padding-top: 0 !important;
        height: 65px;
    }

    ::v-deep .error-row {
        background-color: #ffa1a1 !important;
        border-color: #ffa1a1 !important;
    }

    .warning-icon {
        font-size: 18px;
        color: #ff0000;
        vertical-align: bottom;
    }

    .warning-icon-header {
        font-size: 18px;
        vertical-align: bottom;
    }
</style>